import { makeRequest } from 'utils/requestLogger';

export default (payload) =>
  makeRequest(
    'put',
    `/api/comments/${payload.id}/edit-model-submission`,
    payload
  );



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/comment/editModelSubmission.js